export default theme => ({
  crudTitle: {
    float: 'left',
    marginBottom: 0,
    padding: '8px 0',
    color: theme.palette.primary.main,
  },
  divider: {
    marginTop: '1em',
    marginBottom: '1em',
  },
  sectionTitle: {
    marginBottom: '1em',
    color: theme.palette.primary.main,
  },
  iconTransfert: {
    color: theme.palette.primary.main,
    marginRight: '0.5em',
    fontSize: '1em',
  },
  graphScroll: {
    overflowX: 'auto',
    maxWidth: '100%',
    paddingBottom: '0.5em',
  },
  legend: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '4px',
    marginBottom: '0.75em',
  },
  legendItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  legendSwatch: {
    display: 'inline-block',
    width: '18px',
    height: '14px',
    borderRadius: '3px',
    border: '1px solid rgba(11,11,11,0.10)',
  },
  legendLabel: {
    fontSize: '0.75rem',
    color: '#52514e',
    marginRight: '6px',
  },
})
